import { render, staticRenderFns } from "./image-preview.vue?vue&type=template&id=9c2c54fe&scoped=true&"
import script from "./image-preview.vue?vue&type=script&lang=js&"
export * from "./image-preview.vue?vue&type=script&lang=js&"
import style0 from "./image-preview.vue?vue&type=style&index=0&id=9c2c54fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2c54fe",
  null
  
)

export default component.exports